import { __ } from '@wordpress/i18n';
import { useBlockProps } from '@wordpress/block-editor';
import './editor.scss';

import blockData from "./block.json";

import ReadonlyBlockNotice from "../../../components/ReadonlyBlockNotice";



export default function Edit() {
	return (
		<ReadonlyBlockNotice
			title={__(blockData.title, blockData.textdomain)}
			description={__(blockData.description, blockData.textdomain)}
			notice={__(
				"Ce bloc est non modifiable dans l’éditeur.",
				blockData.textdomain,
			)}
		/>
	);
}
